export function sizeInBytes(mb) {
  return mb * 1048576
}

export const readFileAsDataURL = (file, callback): Promise<string> => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = result => resolve(callback(result));
  });
};

export const validateImage = (image, size = 10) => {
  const max = sizeInBytes(size);
  const lastCharacterNumber = image.slice(-2) === "==" ? 2 : 1;
  const imageSize = image.length * (3 / 4) - lastCharacterNumber;
  return imageSize < max;
};
